import { useIntl } from "react-intl";
import {
  StyledDuration,
  StyledGrowContainer,
  StyledStatsBadge,
} from "../index.styled";

export type NewTextProps = {
  title?: string | number | JSX.Element;
  data: string | number;
  color?: string;
  colorType?: "dark" | "transparent";
  duration?: string;
};

type Props = {
  data: NewTextProps;
  loading?: boolean;
};

export default function NewText({ data, loading }: Props) {
  const { messages } = useIntl();

  const title =
    data.title !== undefined ? data.title : (messages["common.new"] as string);

  if (loading) return null;
  return (
    <StyledGrowContainer>
      <StyledStatsBadge color={data.color} className={`${data.colorType}`}>
        {title} <b>{data.data}</b>
      </StyledStatsBadge>

      <StyledDuration>{data.duration}</StyledDuration>
    </StyledGrowContainer>
  );
}
